import { api } from '../api';

import type { ConfigurationResponse } from './types';

export default {
    async getConfiguration(): Promise<ConfigurationResponse> {
        const response = await api.get('/configuration');

        return response.data;
    },
};
